<template>
  <div class="lead-form-container">
    <!-- Header -->
    <header class="header">
      <div class="header-content">
        <div class="logo-section">
          <a href="https://stationops.com" class="logo-link">
            <img src="https://stationops.com/images/logo.png" alt="STATIONOPS" class="logo-image" />
            <span class="stationops-text">STATIONOPS</span>
          </a>
          
          <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRg33ERt5IfxgBFt5z2eTUsbhasv2Cxocd7bg&s" alt="AWS Partner" class="aws-partner-logo" />
        </div>
        <div class="header-actions">
          <button class="trials-button" style="display: none;">Trials & Downloads</button>
          <div class="menu-container">
            <button class="menu-button" @click="toggleMenu">
              <span></span>
              <span></span>
              <span></span>
            </button>
            <div v-if="isMenuOpen" class="menu-dropdown">
              <a href="https://stationops.com/#product" class="menu-link">Product</a>
              <a href="https://stationops.com/platform" class="menu-link">Platform</a>
              <a href="https://stationops.com/blog" class="menu-link">Blog</a>
              <a href="https://stationops.com/docs" class="menu-link">Docs</a>
              <a href="https://stationops.com/pricing" class="menu-link">Pricing</a>
              <div class="menu-divider"></div>
              <a href="https://app.stationops.com/signin" class="menu-link">Sign in</a>
              <a href="https://app.stationops.com/signup" class="menu-link">Sign up</a>
            </div>
          </div>
        </div>
      </div>
    </header>

    <!-- Page Header -->
    <div class="page-header">
      <div class="custom-report-label">CUSTOM REPORT</div>
      <h1 class="page-title">Your Free AWS<br> Infrastructure Review</h1>
    </div>

    <div style="margin-top: 0px" class="report-info">

    <div class="checkmark-line">
      <span class="checkmark">✓</span>
      <span>Understand the gaps in your AWS infrastructure</span>
    </div>


         <!-- Checkmark line -->
    <div class="checkmark-line">
      <span class="checkmark">✓</span>
      <span>Aligned with the CIS AWS Foundations Benchmark</span>
    </div>

       <div class="checkmark-line">
      <span class="checkmark">✓</span>
      <span>Comprehensive, easy-to-read PDF report</span>
    </div>

    </div>

    <!-- Meet Your Reviewer Section -->
    <div class="reviewer-section">
      <h3 class="reviewer-title">Meet your reviewer</h3>
      <div class="reviewer-content">
        <img src="/conor.png" alt="Conor O Coldatain Lachtna" class="reviewer-image" />
        <div class="reviewer-info">
          <div class="reviewer-name-row">
            <h4 class="reviewer-name">Conor O Coldatain Lachtna</h4>
            <a href="https://www.linkedin.com/in/conor-o-codlatain-lachtna/" target="_blank" rel="noopener noreferrer" class="linkedin-badge" aria-label="LinkedIn">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
          </div>
          <p class="reviewer-certification">
            Certified AWS Security Expert
            <a href="https://www.credly.com/badges/9e0a4aa2-3d06-47c7-b91f-26fb578b3002/public_url" target="_blank" rel="noopener noreferrer" class="credly-link" aria-label="View Credly Badge">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="badge-check" class="svg-inline--fa fa-badge-check fa-w-16 verify-badge__badge-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"></path></svg>
            </a>
          </p>
        </div>
      </div>
    </div>
 

    <!-- Main Form -->
    <div class="form-section">
      <h2 class="form-title" style="display: none;">Download Now</h2>
      <div class="form-box">
        <form @submit.prevent="handleSubmit" class="lead-form">
        <div class="form-group">
          <input
            type="text"
            id="name"
            v-model="formData.name"
            @blur="validateField('name')"
            :class="{ 'error': errors.name }"
            placeholder="Name"
          />
          <span v-if="errors.name" class="error-message">{{ errors.name }}</span>
        </div>
        <div class="form-group">
          <input
            type="text"
            id="businessEmail"
             autocapitalize="off"
             spellcheck="false"
             autocorrect="off"
            v-model="formData.businessEmail"
            @blur="validateField('businessEmail')"
            :class="{ 'error': errors.businessEmail }"
            placeholder="Business Email"
          />
          <span v-if="errors.businessEmail" class="error-message">{{ errors.businessEmail }}</span>
        </div>
        <div class="form-group">
          <select
            id="time"
            v-model="formData.time"
            @blur="validateField('time')"
            :class="{ 'error': errors.time }"
            :disabled="loadingTimes || availableTimes.length === 0"
            class="time-select"
          >
            <option value="" disabled selected>{{ loadingTimes ? 'Loading times...' : availableTimes.length === 0 ? 'No times available' : 'Select a time' }}</option>
            <optgroup v-for="(times, dayKey) in groupedTimes" :key="dayKey" :label="dayKey">
              <option v-for="timeSlot in times" :key="timeSlot.start_time" :value="timeSlot.start_time">
                {{ formatTimeOnly(timeSlot.start_time) }}
              </option>
            </optgroup>
          </select>
          <span v-if="errors.time" class="error-message">{{ errors.time }}</span>
        </div>
        <button type="submit" class="continue-button" :disabled="isBooking">
          <span v-if="isBooking" class="spinner"></span>
          <span v-else>Book discovery call</span>
        </button>
      </form>
      
      <!-- Confirmation Message -->
      <div v-if="bookingConfirmation" class="confirmation-message">
        <div class="confirmation-icon">✓</div>
        <h3 class="confirmation-title">Booking Confirmed!</h3>
        <p class="confirmation-text">
          Your discovery call is scheduled for <br><strong>{{ formattedBookingTime }}</strong>
        </p>
        <p class="confirmation-text">
          A calendar invite has been sent to <strong>{{ formData.businessEmail }}</strong>
        </p>
      </div>
      </div>
    </div>

    <!-- Footer Notice -->
    <div v-if="showPrivacyNotice" class="footer-notice">
      <p>
        By continuing to use our website, you acknowledge the use of cookies.
        <a href="https://stationops.com/privacy" class="privacy-link">Privacy Statement ></a>
      </p>
      <button class="close-button" @click="closePrivacyNotice" aria-label="Close">×</button>
    </div>

    <!-- Footer -->
    <footer class="main-footer">
      <div class="footer-content">
        <div class="footer-links">
          <a href="https://stationops.com/privacy" class="footer-link">Privacy</a>
          <a href="https://stationops.com/terms" class="footer-link">Terms and conditions</a>
          <a href="https://stationops.com/cookies" class="footer-link">Cookies</a>
          <a href="https://www.linkedin.com/company/stationops/" class="footer-link" target="_blank" rel="noopener noreferrer">LinkedIn</a>
        </div>
        <div class="footer-copyright">
          © 2025 StationOps. All rights reserved.
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'

// 1️⃣ Auto-select API base URL based on environment
function apiBaseUrl() {
  return window.location.hostname === "localhost"
    ? "http://localhost:8080"
    : "https://api.stationops.com";
}

// 2️⃣ Fetch available times from backend using native fetch
async function fetchAvailableTimes(eventTypeUri) {
  const base = apiBaseUrl();
  const url = `${base}/booking/available-times?event_type=${encodeURIComponent(eventTypeUri)}`;

  const res = await fetch(url);

  if (!res.ok) {
    throw new Error(`API error: ${res.status}`);
  }

  const json = await res.json();

  if (!json.success) {
    throw new Error(json.error || "Failed to load times");
  }

  return json.times; // Array of time slots
}

// 3️⃣ Create a booking through backend → backend calls Calendly
async function createBooking(bookingData) {

  fbq('track', 'SubmitApplication');

  const base = apiBaseUrl();

  const res = await fetch(`${base}/booking/book`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(bookingData)
  });

  if (!res.ok) {
    throw new Error(`API error: ${res.status}`);
  }

  const json = await res.json();

  if (!json.success) {
    throw new Error(json.error || "Failed to create booking");
  }

  return json; // includes meetingUuid + Calendly response
}


const formData = ref({
  name: '',
  businessEmail: '',
  time: ''
})

const availableTimes = ref([])
const loadingTimes = ref(false)
const isMenuOpen = ref(false)
const showPrivacyNotice = ref(true)
const isBooking = ref(false)
const bookingConfirmation = ref(false)
const errors = ref({
  name: '',
  businessEmail: '',
  time: ''
})

// Event type URI - update this with your actual event type
const EVENT_TYPE_URI = 'https://api.calendly.com/event_types/d6302867-98dd-4ef6-aa45-ee55d1253116'

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
}

// Cookie utility functions
const setCookie = (name, value, days = 365) => {
  const date = new Date()
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
  const expires = `expires=${date.toUTCString()}`
  document.cookie = `${name}=${value};${expires};path=/`
}

const getCookie = (name) => {
  const nameEQ = `${name}=`
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

const closePrivacyNotice = () => {
  setCookie('privacyNoticeClosed', 'true')
  showPrivacyNotice.value = false
}

const handleClickOutside = (event) => {
  const menuContainer = event.target.closest('.menu-container')
  if (!menuContainer && isMenuOpen.value) {
    isMenuOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
  // Check if privacy notice was previously closed
  if (getCookie('privacyNoticeClosed') === 'true') {
    showPrivacyNotice.value = false
  }
  // Load available times on mount
  loadAvailableTimes()
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})

const formatDayLabel = (isoString) => {
  const date = new Date(isoString)
  const now = new Date()
  
  // Reset time to midnight for date comparison
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate())
  
  // Calculate days difference
  const daysDiff = Math.floor((dateOnly - today) / (1000 * 60 * 60 * 24))
  
  // Format day name
  const dayName = date.toLocaleString('en-US', {
    weekday: 'long',
    month: 'short',
    day: 'numeric'
  })
  
  if (daysDiff === 0) {
    return `${dayName} (Today)`
  } else if (daysDiff === 1) {
    return `${dayName} (Tomorrow)`
  } else {
    return `${dayName} (in ${daysDiff} days)`
  }
}

const formatTimeOnly = (isoString) => {
  const date = new Date(isoString)
  return date.toLocaleString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  })
}

const groupedTimes = computed(() => {
  const groups = {}
  
  availableTimes.value.forEach(timeSlot => {
    const date = new Date(timeSlot.start_time)
    // Create a key based on the date (YYYY-MM-DD)
    const dateKey = date.toISOString().split('T')[0]
    
    if (!groups[dateKey]) {
      groups[dateKey] = []
    }
    groups[dateKey].push(timeSlot)
  })
  
  // Convert to object with formatted labels and sort by date
  const result = {}
  Object.keys(groups)
    .sort()
    .forEach(dateKey => {
      const label = formatDayLabel(groups[dateKey][0].start_time)
      result[label] = groups[dateKey].sort((a, b) => 
        new Date(a.start_time) - new Date(b.start_time)
      )
    })
  
  return result
})

const formattedBookingTime = computed(() => {
  if (!formData.value.time) return ''
  const date = new Date(formData.value.time)
  const now = new Date()
  
  // Reset time to midnight for date comparison
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate())
  
  // Calculate days difference
  const daysDiff = Math.floor((dateOnly - today) / (1000 * 60 * 60 * 24))
  
  let dayLabel = ''
  if (daysDiff === 0) {
    dayLabel = '(Today)'
  } else if (daysDiff === 1) {
    dayLabel = '(Tomorrow)'
  } else {
    dayLabel = `(in ${daysDiff} days)`
  }
  
  // Format time
  const time = date.toLocaleString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  })
  
  // Format day name
  const dayName = date.toLocaleString('en-US', {
    weekday: 'short'
  })
  
  return `${dayName} ${time} ${dayLabel}`
})

const validateField = (fieldName) => {
  const value = formData.value[fieldName]
  
  switch (fieldName) {
    case 'name':
      if (!value || value.trim() === '') {
        errors.value.name = 'Name is required'
      } else {
        errors.value.name = ''
      }
      break
    case 'businessEmail':
      if (!value || value.trim() === '') {
        errors.value.businessEmail = 'Business email is required'
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        errors.value.businessEmail = 'Please use your business email'
      } else {
        // Check for personal email providers
        const emailDomain = value.toLowerCase().split('@')[1]
        const personalEmailDomains = ['gmail.com', 'hotmail.com', 'yahoo.com', 'outlook.com', 'yahoo.co.uk', 'hotmail.co.uk', 'outlook.co.uk']
        
        if (personalEmailDomains.some(domain => emailDomain === domain || emailDomain.endsWith('.' + domain))) {
          errors.value.businessEmail = 'Please use your business email'
        } else {
          errors.value.businessEmail = ''
        }
      }
      break
    case 'time':
      if (!value || value === '') {
        errors.value.time = 'Please select a time'
      } else {
        errors.value.time = ''
      }
      break
  }
}

const validateForm = () => {
  validateField('name')
  validateField('businessEmail')
  validateField('time')
  
  return !errors.value.name && !errors.value.businessEmail && !errors.value.time
}

const loadAvailableTimes = async () => {
  loadingTimes.value = true
  try {
    const times = await fetchAvailableTimes(EVENT_TYPE_URI)
    // Filter to only show available times and ensure they have invitees remaining
    availableTimes.value = times.filter(timeSlot => 
      timeSlot.status === 'available' && timeSlot.invitees_remaining > 0
    )
  } catch (error) {
    console.error('Failed to load times:', error)
    alert('Failed to load available times. Please try again later.')
  } finally {
    loadingTimes.value = false
  }
}

const handleSubmit = async () => {
  // Validate all fields
  if (!validateForm()) {
    return
  }

  isBooking.value = true
  bookingConfirmation.value = false

  try {
    // Ensure time is in ISO format (should already be from API response)
    const isoTime = formData.value.time
    
    const bookingData = {
      event_type: EVENT_TYPE_URI,
      time: isoTime, // ISO format: "2025-11-24T09:30:00Z"
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      email: formData.value.businessEmail,
      name: formData.value.name
    }

    const result = await createBooking(bookingData)
    console.log('Booking created:', result)
    
    // Show confirmation
    isBooking.value = false
    bookingConfirmation.value = true
    
    // Hide form
    const form = document.querySelector('.lead-form')
    if (form) {
      form.style.display = 'none'
    }
  } catch (error) {
    console.error('Failed to create booking:', error)
    isBooking.value = false
    alert(`Failed to create booking: ${error.message}`)
  }
}
</script>

<style scoped>
.lead-form-container {
  min-height: 100vh;
  background-color: #ffffff;
  font-family: 'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
}

.header {
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  padding: 10px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.logo-section a {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    text-decoration: none;

}

.logo-image {
  height: 20px;
  width: auto;
}

.aws-partner-logo {
  height: 20px;
  width: auto;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.trials-button {
  background-color: #000000;
  color: #ffffff;
  border: none;
  padding: 0.6rem 1.2rem;
  border-radius: 4px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.trials-button:hover {
  background-color: #333333;
}

.menu-button {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
}

.menu-button span {
  width: 20px;
  height: 2px;
  background-color: #000000;
  display: block;
}

.menu-container {
  position: relative;
}

.menu-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.5rem;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  z-index: 1000;
  padding: 0.5rem 0;
}

.menu-link {
  display: block;
  padding: 0.75rem 1.5rem;
  color: #333333;
  text-decoration: none;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}

.menu-link:hover {
  background-color: #f5f5f5;
  color: #9333EA;
}

.menu-divider {
  height: 1px;
  background-color: #e0e0e0;
  margin: 0.5rem 0;
}

.checkmark-line {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
  font-size: 0.9rem;
  color: #333333;
}

.report-info .checkmark-line {
  padding: 0.5rem 0;
}

.stationops-text {
  font-size: 1.1rem;
  font-weight: 600;
  color: #000000;
}

.checkmark {
  color: #9333EA;
  font-weight: bold;
  font-size: 1.2rem;
}

.page-header {
  max-width: 500px;
  margin: 2rem auto 0;
  padding: 0 1rem 0;
  text-align: left;
  margin-bottom: 10px;
  margin-top: 20px;
}

.custom-report-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #9333EA;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 0.5rem;
}

.page-title {
  font-size: 2rem;
  font-weight: 600;
  color: #000000;
  margin: 0;
  line-height: 1.3;
}

.report-info {
  max-width: 500px;
  margin: 2rem auto;
  padding: 0 1rem;
  margin-bottom: 1.5rem;
}

.reviewer-section {
  max-width: 500px;
  margin: 2rem auto;
  padding: 0 1rem;
  margin-top: 1rem;
}

.reviewer-title {
  font-size: 1rem;
  font-weight: 600;
  color: #000000;
  margin-bottom: 0.5rem;
  text-align: left;
}

.reviewer-content {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}

.reviewer-image {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 4px solid #e0e0e0;
}

.reviewer-info {
  flex: 1;
  margin-top: 0.1rem;
}

.reviewer-name-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.25rem;
}

.reviewer-name {
  font-size: 1rem;
  font-weight: 600;
  color: #000000;
  margin: 0;
}

.linkedin-badge {
  color: #0a66c2;
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: opacity 0.2s;
}

.linkedin-badge:hover {
  opacity: 0.8;
}

.reviewer-certification {
  font-size: 0.9rem;
  color: #666666;
  margin: 0;
  line-height: 1.5;
}

.credly-link {
  display: inline-flex;
  align-items: center;
  color: #9333EA;
  text-decoration: none;
  margin-left: 0.5rem;
  transition: color 0.2s;
  vertical-align: middle;
  padding-bottom: 4px;
}

.credly-link svg {
  width: 18px;
  height: 18px;
}

.credly-link:hover {
  color: #7c22ce;
}

.credly-link:hover svg {
  transform: scale(1.1);
  transition: transform 0.2s;
}

.form-section {
  max-width: 500px;
  margin: 2rem auto;
  padding: 0 1rem;
}

.form-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #000000;
  margin-bottom: 2rem;
  text-align: left;
}

.form-box {
  border: 1px solid #e0e0e0;
  border-top: 3px solid #9333EA;
  border-radius: 4px;
  padding: 2rem;
  background-color: #ffffff;
}

.lead-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group input,
.form-group select {
  padding: 0.8rem;
  border: 1px solid #cccccc;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.2s;
  font-family: 'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  box-sizing: border-box;
  height: auto;
  min-height: 48px;
  line-height: 1.5;
}

.form-group input::placeholder {
  color: #999999;
  opacity: 1;
}

.form-group select::placeholder {
  color: #999999;
  -webkit-text-fill-color: #999999;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #9333EA;
  box-shadow: 0 0 0 2px rgba(147, 51, 234, 0.1);
}

.form-group input.error,
.form-group select.error {
  border-color: #dc2626;
}

.form-group input.error:focus,
.form-group select.error:focus {
  border-color: #dc2626;
  box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.1);
}

.form-group select {
  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.8rem center;
  background-size: 12px;
  padding-right: 2.5rem;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  height: auto;
  min-height: 48px;
  line-height: 1.5;
  color: #333333;
}

.form-group select option {
  color: #333333;
  background-color: #ffffff;
}

.form-group select option:disabled {
  color: #999999;
  -webkit-text-fill-color: #999999;
}

.form-group select:invalid {
  color: #999999;
  -webkit-text-fill-color: #999999;
}

.form-group select:not(:invalid) {
  color: #333333;
  -webkit-text-fill-color: #333333;
}


.form-group select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.6;
}

.error-message {
  display: block;
  color: #dc2626;
  font-size: 0.75rem;
  margin-top: 0.25rem;
  font-family: 'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
}

.continue-button {
  background-color: #9333EA;
  color: #ffffff;
  border: none;
  padding: 1rem;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 48px;
}

.continue-button:hover:not(:disabled) {
  background-color: #7c22ce;
}

.continue-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #ffffff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.confirmation-message {
  margin-top: 2rem;
  padding: 2rem;
  background-color: #f0fdf4;
  border: 1px solid #86efac;
  border-radius: 4px;
  text-align: center;
}

.confirmation-icon {
  width: 60px;
  height: 60px;
  background-color: #22c55e;
  color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: bold;
  margin: 0 auto 1rem;
}

.confirmation-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #000000;
  margin-bottom: 1rem;
}

.confirmation-text {
  font-size: 1rem;
  color: #333333;
  margin: 0.5rem 0;
  line-height: 1.6;
}

.confirmation-text strong {
  color: #9333EA;
  font-weight: 600;
}

.footer-notice {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background-color: #f5f5f5;
  border-top: 1px solid #e0e0e0;
  font-size: 0.85rem;
  color: #666666;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.footer-notice p {
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #666666;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transition: color 0.2s;
}

.close-button:hover {
  color: #000000;
}

.privacy-link {
  color: #9333EA;
  text-decoration: none;
  margin-left: 0.3rem;
}

.privacy-link:hover {
  text-decoration: underline;
}

.main-footer {
  background-color: #ffffff;
  border-top: 1px solid #e0e0e0;
  padding: 2rem 1rem;
  margin-top: 3rem;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
  align-items: center;
}

.footer-link {
  color: #333333;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s;
}

.footer-link:hover {
  color: #9333EA;
  text-decoration: underline;
}

.footer-copyright {
  color: #666666;
  font-size: 0.85rem;
  text-align: center;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .header {
    padding: 10px;
  }

  .logo-image {
    height: 20px;
  }


  .trials-button {
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
  }

 

  .page-title {
    font-size: 1.75rem;
  }

  .form-section {
    margin: 1.5rem auto;
    padding: 0 1rem;
  }

  .form-title {
    font-size: 1.5rem;
  }

  .footer-notice {
    font-size: 0.8rem;
    padding: 0.8rem;
  }

  .reviewer-section {
    margin: 1.5rem auto;
    margin-top: 1rem;
  }
}
</style>
